import { render, staticRenderFns } from "./popup-material-other.vue?vue&type=template&id=1f5b5312&scoped=true"
import script from "./popup-material-other.vue?vue&type=script&lang=js"
export * from "./popup-material-other.vue?vue&type=script&lang=js"
import style0 from "./popup-material-other.vue?vue&type=style&index=0&id=1f5b5312&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b5312",
  null
  
)

export default component.exports